import i from"styled-components";import{theme as r}from"../../../theme.js";const o=i.div`
  background-color: ${r.colors.gray[50]};
  padding: ${r.spacing*4}px ${r.spacing*6}px;
  border-radius: ${r.radius}px;
  display: flex;
  flex-direction: column;
  gap: ${r.spacing*4}px;
  > img {
    aspect-ratio: 16/9;
    object-fit: cover;
    border-radius: ${r.radius}px;
  }
  > h3 {
    margin: 0;
    color: ${r.colors.gray[900]};
    font-size: 18px;
    line-height: 27px;
  }
  > button {
    background: unset;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    justify-content: space-between;
    border: unset;
    padding: unset;
    cursor: pointer;
    font-weight: 700;
    color: ${r.colors.primary[500]};
    > svg {
      width: 24px;
      height: 24px;
      transform: rotate(-180deg);
      g, path {
        fill: ${r.colors.primary[500]};
      }
    }
  }
`,t=i.div`
  position: relative;
  width: 100%;
  > img {
    aspect-ratio: 16/9;
    object-fit: cover;
    width: 100%;
    border-radius: ${r.radius}px;
  }
  > svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 50px;
    height: 50px;
    g, path {
      fill: ${r.colors.primary[500]};
    }
  }
`;export{o as Container,t as PictureContainer};
